type ProposalSegment = HTMLElement | undefined;

export function syncProposalSegmentHeights(
  root: ParentNode | null,
  additionalSegmentSelector?: string
): void {
  if (!root) {
    return;
  }

  const cards = Array.from(root.querySelectorAll<HTMLElement>('.compare_top'));
  const segments = cards.map((card): ProposalSegment[] => {
    const children = Array.from(card.children) as HTMLElement[];
    const sections = children.filter((child) =>
      child.classList.contains('prt')
    );
    const features = children.filter((child) =>
      child.classList.contains('ftrs')
    );

    return [
      children[0],
      children.find((child) => child.classList.contains('proposal-badges')),
      children.find((child) => child.classList.contains('offerid')),
      children.find((child) => child.classList.contains('price')),
      sections.find(
        (section) =>
          !['offerid', 'price', 'downld', 'ftrs'].some((name) =>
            section.classList.contains(name)
          )
      ),
      children.find((child) => child.classList.contains('downld')),
      features[0],
      features[1],
      additionalSegmentSelector
        ? children.find((child) => child.matches(additionalSegmentSelector))
        : undefined,
    ];
  });

  segments.flat().forEach((segment) => {
    if (segment) {
      segment.style.minHeight = '';
      segment.style.marginTop = '';
    }
  });

  const heights = segments[0]?.map((_, index) =>
    Math.max(
      ...segments.map((cardSegments) => cardSegments[index]?.offsetHeight ?? 0)
    )
  );

  segments.forEach((cardSegments) => {
    let missingSegmentHeight = 0;
    cardSegments.forEach((segment, index) => {
      if (!segment) {
        missingSegmentHeight += heights?.[index] ?? 0;
        return;
      }
      segment.style.minHeight = `${heights?.[index] ?? 0}px`;
      if (missingSegmentHeight) {
        segment.style.marginTop = `${missingSegmentHeight}px`;
        missingSegmentHeight = 0;
      }
    });
  });
}
